export default {
  markdown: null,
  convertedHtml: null,
  //page context
  editable: null,
  toRoot: null,
  title: null,
  screen: null,
  absolutesScreen: null,
  svgCanvas: null,
  body: null,
  updatedAuthorName: null,
  updatedDate: null,
  createdAuthorName: null,
  createdDate: null,
}
